module.exports = __webpack_public_path__ + "images/66df39db20d9225276ed8fffe24ead1d.png";